import { render, staticRenderFns } from "./InvestList.vue?vue&type=template&id=61428e90&scoped=true&"
import script from "./InvestList.vue?vue&type=script&lang=js&"
export * from "./InvestList.vue?vue&type=script&lang=js&"
import style0 from "./InvestList.vue?vue&type=style&index=0&id=61428e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61428e90",
  null
  
)

export default component.exports